/* eslint-disable no-unused-vars */
import {
  Button,
  Card,
  Grid,
  IconButton,
  InputAdornment,
  Typography,
} from "@mui/material";
import { grey, orange, purple, green } from "@mui/material/colors";
import BackspaceIcon from "@mui/icons-material/Backspace";
import PAuthenticationWindow from "../../../components/pos/PAuthenticationWindow";
import PConfirm from "../../../components/pos/PConfirm";
import PText from "../../../components/pos/PText";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { PoleDisplayUtils } from "../../../utils/PoleDisplayUtils";
import { PricingUtils } from "../../../utils/PricingUtils";
import { createTheme, styled, ThemeProvider } from "@mui/material/styles";
import PCheck from "../../../components/pos/PCheck";
import db from "../../../db/db";

const theme = createTheme({
  status: {
    danger: orange[500],
  },

  components: {
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: "1.25rem",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          padding: 5,
        },
        adornedEnd: {
          paddingRight: 0,
        },
      },
    },
  },
});

// const ActionButton = styled(Button)({
//   width: "100%",
//   height: "100%",
//   fontSize: "10px",
// });

const ActionButton = styled(Button)({
  width: "100%",
  height: "100%",
  fontSize: "1.28rem",
  color: theme.palette.getContrastText(purple[500]),
  backgroundColor: green[500],
  "&:hover": {
    backgroundColor: green[700],
  },
});

const SettleButton = styled(Button)({
  width: "100%",
  height: "100%",
  fontSize: "1.5rem",
  color: theme.palette.getContrastText(purple[500]),
  backgroundColor: purple[500],
  "&:hover": {
    backgroundColor: purple[700],
  },
  "& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
    {
      display: "none",
      margin: 80,
    },
  "&$disabled": {
    color: theme.palette.text.primary,
    "&:before": {
      borderBottom: "none!important",
    },
    "& svg": {
      display: "none",
    },
  },
});

let prevTime = 0;
export default function PaymentCard(props) {
  const { t } = useTranslation();
  const translate = t;
  const [showBalance, seltShowBalance] = useState(false);
  const [amountObj, setAmountObj] = useState({
    amt: "0",
    srcAdj: 0,
    baseAdj: 0,
  });
  const [balance, setBalance] = useState("false");
  const [code, setCode] = useState("");
  const [discountLimt, setDiscountLimt] = useState(null);
  const [isDiscountInPercentage, setIsDiscountInPercentage] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [showDiscountApprovalWindow, setShowDiscountApprovalWindow] =
    useState(false);
  const [discountDisplayValue, setDiscountDisplayValue] = useState("");
  const [isBalanceInBaseCurrency, setIsBalanceInBaseCurrency] = useState(true);
  const [isBalanceInSourceCurrency, setIsBalanceInSourceCurrency] =
    useState(false);
  const [paymentMode, setPaymentMode] = useState(null);
  const [fxConversionRate, setFxConversionRate] = useState(1);
  const [fxReceived, setFxReceived] = useState(0);
  const [balanceInBaseCurrency, setBalanceInBaseCurrency] = useState(0);
  const [balanceInSourceCurrency, setBalanceInSourceCurrency] = useState(0);
  const [balanceCurrencyType, setBalanceCurrencyType] = useState("BASE");
  const [enableSaleSave, setEnableSaleSave] = useState(true);
  const [selectPrinter, setSelectPrinter] = useState([]);

  useEffect(() => {
    setDiscountLimitByPrivilage();
    getConfigDb();
  }, []);

  useEffect(() => {
    console.log("fxReceived", fxReceived);
  }, [fxReceived]);

  useEffect(() => {
    if (showDiscountApprovalWindow) props.setEnableKeyListeners(false);
    else props.setEnableKeyListeners(true);
  }, [showDiscountApprovalWindow]);

  useEffect(() => {
    let selectedPaymentMode = "";
    for (let d of props.paymentOptions) {
      if (d.selected) {
        setPaymentMode(d);
        setCode(d.code);
        selectedPaymentMode = d;
        if (d.code === "CASH" || d.isFx) {
          seltShowBalance(true);
        } else {
          seltShowBalance(false);
        }
      }
    }
    deriveAmount(selectedPaymentMode);
  }, [props.paymentOptions]);

  useEffect(() => {
    handleAmountChange();
  }, [amountObj]);

  useEffect(() => {
    if (isBalanceInBaseCurrency) handleAmountChange();
  }, [isBalanceInBaseCurrency]);

  useEffect(() => {
    if (isBalanceInSourceCurrency) handleAmountChange();
  }, [isBalanceInSourceCurrency]);

  async function handleAmountChange() {
    if (code === "CASH" || (paymentMode && paymentMode.isFx)) {
      let tot = 0;
      for (let d of props.paymentData) {
        if (d.code !== code) {
          tot = tot + parseFloat(d.amount);
        }
      }

      let totalInvoiceAmount = parseFloat(props.total);

      if (paymentMode && paymentMode.isFx) {
        console.log("##amountObj", amountObj);
        let conversionRate = await getConversionRate(paymentMode.code);
        tot = tot + amountObj.amt * conversionRate;
        tot = await deriveFxPrice(tot, paymentMode.code);
        totalInvoiceAmount = await deriveFxPrice(
          totalInvoiceAmount,
          paymentMode.code
        );
      } else {
        tot = tot + parseFloat(amountObj.amt);
      }
      if (parseFloat(tot) > parseFloat(totalInvoiceAmount)) {
        let balance = "";
        if (paymentMode && paymentMode.isFx) {
          if (isBalanceInSourceCurrency) {
            balance = PricingUtils.formattedNumber(
              tot - parseFloat(totalInvoiceAmount) - amountObj.srcAdj,
              props.context.store.currencyDecimal
            );
            setBalanceCurrencyType("SOURCE");
            setBalanceInSourceCurrency(balance);
            setFxReceived(
              PricingUtils.formattedNumber(
                parseFloat(tot) - parseFloat(balance),
                props.context.store.currencyDecimal
              )
            );
            console.log(
              "Track set FxReceived",
              parseFloat(tot) - parseFloat(balance)
            );
          } else {
            let balanceInFx = tot - parseFloat(totalInvoiceAmount);
            let conversionRate = await getConversionRate(paymentMode.code);

            balance = PricingUtils.formattedNumber(
              balanceInFx * conversionRate - amountObj.baseAdj,
              props.context.store.currencyDecimal
            );
            setBalanceCurrencyType("BASE");
            setBalanceInBaseCurrency(balance);
            setFxReceived(
              PricingUtils.formattedNumber(
                parseFloat(amountObj.amt),
                props.context.store.currencyDecimal
              )
            );
            console.log("Track set FxReceived", tot);
          }
        } else {
          balance = PricingUtils.formattedNumber(
            tot - parseFloat(totalInvoiceAmount),
            props.context.store.currencyDecimal
          );
          setBalanceCurrencyType("BASE");
          setBalanceInBaseCurrency(balance);
        }
        setBalance(balance);
      } else {
        if (paymentMode && paymentMode.isFx) {
          setFxReceived(parseFloat(amountObj.amt));
          console.log("Track set FxReceived", amountObj.amt);
        } else {
          setFxReceived(0);
          console.log("Track set FxReceived", amountObj.amt);
        }
        setBalance("");
      }
    } else if (code === "DISCOUNT") {
      deriveDiscountDisplayValues();
    }
  }

  useEffect(() => {
    let selectedPaymentMode = "";
    for (let d of props.paymentOptions) {
      if (d.selected) {
        setCode(d.code);
        selectedPaymentMode = d;
        if (d.code === "CASH" || d.isFx) {
          seltShowBalance(true);
        } else {
          seltShowBalance(false);
        }
      }
    }
    deriveAmount(selectedPaymentMode);
  }, [props.total]);

  function setDiscountLimitByPrivilage() {
    try {
      if (
        props.privileges.sale_discount_allowed != null &&
        props.privileges.sale_discount_allowed != undefined &&
        props.privileges.sale_discount_allowed === true &&
        props.privileges.sale_discount_max_per_limit != null &&
        props.privileges.sale_discount_max_per_limit != undefined
      ) {
        let discountLimit = props.privileges.sale_discount_max_per_limit;
        setDiscountLimt(parseFloat(discountLimit));
      } else {
        setDiscountLimt(null);
      }
    } catch (err) {
      setDiscountLimt(null);
    }
  }

  props.pRefs.paymentCard = {
    parentEvent: parentEvent,
  };

  function parentEvent(event, value1, value2, value3) {
    if (event === "onKeyPressed") {
      onKeyPressedEvent(value1);
    }
    if (event === "getSetEnableSaleSaveFn") {
      return setEnableSaleSave;
    }
    if (event === "getEnableSaleSave") {
      return enableSaleSave;
    }
  }

  function onKeyPressedEvent(value) {
    if ("Backspace" === value) {
      if (amountObj.amt.length > 0) {
        setAmountObj({
          amt: amountObj.amt.substring(0, amountObj.amt.length - 1),
          srcAdj: amountObj.srcAdj,
          baseAdj: amountObj.srcAdj,
        });
      }
    } else if ("Delete" === value) {
      setAmountObj({ amt: "", srcAdj: 0, baseAdj: 0 });
    } else if (value === "Enter") {
      pushToPaymentItem();
    } else if (isValidkey(value)) {
      let curTime = new Date().getTime();
      if (curTime - prevTime < 2000) {
        setAmountObj({
          amt: amountObj.amt + "" + value,
          srcAdj: amountObj.srcAdj,
          baseAdj: amountObj.baseAdj,
        });
      } else {
        setAmountObj({
          amt: value,
          srcAdj: amountObj.srcAdj,
          baseAdj: amountObj.baseAdj,
        });
      }
      prevTime = curTime;
    }
  }

  function deriveDiscountDisplayValues() {
    if (isDiscountInPercentage && amountObj.amt > 100) {
      setDiscountDisplayValue("Invalid!");
      return;
    }
    if (amountObj.amt == null || amountObj.amt == "") {
      setDiscountDisplayValue("");
      return;
    }
    if (
      !isDiscountInPercentage &&
      parseFloat(amountObj.amt) > parseFloat(props.total)
    ) {
      setDiscountDisplayValue("Invalid!");
      return;
    }

    let displayDiscountValue = "";
    if (isDiscountInPercentage) {
      displayDiscountValue = PricingUtils.formattedNumber(
        (parseFloat(amountObj.amt) * parseFloat(props.total)) / 100,
        props.context.store.currencyDecimal
      );
      displayDiscountValue += props.context.store.currency;
    } else {
      displayDiscountValue = PricingUtils.formattedNumber(
        (parseFloat(amountObj.amt) * 100) / parseFloat(props.total),
        props.context.store.currencyDecimal
      );
      displayDiscountValue += "%";
    }
    setDiscountDisplayValue(displayDiscountValue);
  }

  async function getConfigDb() {
    let data = [];
    let dbData = await db.config
      .where("name")
      .equals("PAYMENT_SETTINGS")
      .toArray();

    let configJson = JSON.parse(dbData[0].configTxt);
    for (let d of configJson.printButtons) {
      let i = [
        {
          label: d.label,
          keyBoardShortCut: d.keyBoardShortCut,
        },
      ];
      data.push(i);
    }
    // setSelectPrinter(data[0]);

    setSelectPrinter(data.length == 2 ? data[0] : []);
  }

  function validateDicountPermissions(customDiscountLimit) {
    let maxApplicableDiscPercentage = customDiscountLimit
      ? customDiscountLimit
      : discountLimt;
    if (maxApplicableDiscPercentage && maxApplicableDiscPercentage > 0) {
      if (isDiscountInPercentage && amountObj.amt > 100) {
        props.setAlert({
          show: true,
          title: translate("Alert!"),
          message: translate("Invalid discount percentage"),
        });
        return;
      }

      let discPercentge = 0;
      if (isDiscountInPercentage) discPercentge = amountObj.amt;
      else {
        discPercentge = PricingUtils.formattedNumber(
          (parseFloat(amountObj.amt) * 100) / parseFloat(props.total),
          props.context.store.currencyDecimal
        );
      }

      if (discPercentge > maxApplicableDiscPercentage) {
        setConfirmOpen(true);
        setConfirmContext({
          title: translate("Discount limit exceeds"),
          message: translate(
            "The discount which trying to apply is exceeds the configuration limit, Need to try with another login?"
          ),
          type: "warning",
          open: true,
          yes: true,
          no: true,
        });
      } else {
        if (isDiscountInPercentage) {
          let discountAmount = PricingUtils.formattedNumber(
            (props.total * discPercentge) / 100,
            props.context.store.currencyDecimal
          );
          applySubTotalDiscount(discountAmount);
        } else applySubTotalDiscount(amountObj.amt);
        props.showPaymentCard();
      }
    } else {
      props.setAlert({
        show: true,
        title: translate("Alert!"),
        message: translate("Discount limit is not configured!"),
      });
    }
  }

  function applySubTotalDiscount(discountAmount) {
    let data = [...props.paymentData];
    let newData = [];
    let found = false;
    for (let i = 0; i < data.length; i++) {
      if (data[i].code === "DISCOUNT") {
        found = true;
        newData.push({
          code: code,
          tendered: discountAmount,
          amount: discountAmount,
          balance: 0,
        });
      } else {
        newData.push(data[i]);
      }
    }
    if (!found && code === "DISCOUNT") {
      newData.push({
        code: code,
        tendered: discountAmount,
        amount: discountAmount,
        balance: 0,
      });
    }
    props.setPaymentData(newData);
  }

  function onYesNoClicked(context, value) {
    setConfirmOpen(false);
    if (value == "yes") {
      console.log("YES clicked");
      setShowDiscountApprovalWindow(true);
    }
  }

  function handleLoginSucessResponse(authToken) {
    if (
      window.JSBridge &&
      typeof window.JSBridge !== "undefined" &&
      window.JSBridge !== null
    ) {
      let baseUrl = window.JSBridge.getBaseURL();
      getPrivileges(baseUrl, authToken);
    } else {
      getPrivileges("", authToken);
    }
  }

  async function getPrivileges(baseUrl, authToken) {
    try {
      const response = await fetch(baseUrl + "/auth/v1/users/myPrivileges", {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + authToken,
        },
      });
      if (response.status === 200) {
        const json = await response.json();
        if (
          json.sale_discount_allowed != null &&
          json.sale_discount_allowed != undefined &&
          json.sale_discount_allowed === true &&
          json.sale_discount_max_per_limit != null &&
          json.sale_discount_max_per_limit != undefined
        ) {
          validateDicountPermissions(
            parseFloat(json.sale_discount_max_per_limit)
          );
        } else {
          validateDicountPermissions(null);
        }
      } else {
        props.setAlert({
          show: true,
          title: translate("Alert!"),
          message: translate("Error while fetching privileges!"),
        });
      }
    } catch (e) {
      props.setAlert({
        show: true,
        title: translate("Alert!"),
        message: translate("Something went wrong!"),
      });
    }
  }

  function handleLoginFailedResponse(errorMessage) {
    props.setAlert({
      show: true,
      title: translate("Alert!"),
      message: translate("Login failed!"),
    });
  }

  async function pushToPaymentItem() {
    console.log("Pusg");
    if (validate()) {
      let data = [...props.paymentData];
      let newData = [];
      let found = false;
      if (code === "DISCOUNT") {
        validateDicountPermissions(null);
        return;
      } else {
        props.showPaymentCard();
      }
      for (let i = 0; i < data.length; i++) {
        if (data[i].code === code) {
          found = true;
          await processPaymentItem(newData, "update");
        } else {
          newData.push(data[i]);
        }
      }
      if (!found) {
        await processPaymentItem(newData, "add");
        showPaymentInfoInPole(code, newData);
      }
      props.setPaymentData(newData);
    }
  }

  async function processPaymentItem(arr, mode) {
    if (code === "CASH") {
      let amt = 0;
      let balanceToPay = getBalanceToPay(mode);
      if (parseFloat(amountObj.amt) > balanceToPay) {
        amt = PricingUtils.formattedNumber(
          balanceToPay,
          props.context.store.currencyDecimal
        );
      } else {
        amt = amountObj.amt;
      }
      arr.push({
        tenderedInActualCurr: amountObj.amt,
        amountInActualCurr: amt,
        balanceWithCurrency:
          (balance ? balance : 0) + " " + props.context.store.currency,
        code: "CASH",
        tendered: amountObj.amt,
        amount: amt,
        srcAdj: 0,
        baseAdj: 0,
        balance: balance ? balance : 0,
        fxReceived: fxReceived ? fxReceived : 0,
        balanceInBaseCurrency: balanceInBaseCurrency
          ? balanceInBaseCurrency
          : 0,
        balanceInSourceCurrency: balanceInSourceCurrency
          ? balanceInSourceCurrency
          : 0,
        balanceCurrencyType: balanceCurrencyType ? balanceCurrencyType : "BASE",
      });
    } else if (paymentMode.isFx) {
      let conversionRate = await getConversionRate(paymentMode.code);
      let balanceToPay = getBalanceToPay(mode);
      let amt = 0;
      if (parseFloat(amountObj.amt) * conversionRate > balanceToPay) {
        amt = PricingUtils.formattedNumber(
          balanceToPay,
          props.context.store.currencyDecimal
        );
      } else {
        amt = parseFloat(amountObj.amt) * conversionRate;
      }

      arr.push({
        tenderedInActualCurr: amountObj.amt,
        amountInActualCurr: PricingUtils.formattedNumber(
          amt / conversionRate,
          code === "OMR" ? 3 : 2
        ),
        balanceWithCurrency:
          balanceCurrencyType == "BASE"
            ? balanceInBaseCurrency + " " + props.context.store.currency
            : balanceInSourceCurrency + " " + code,

        code: code,
        tendered: amountObj.amt,
        srcTendered: amountObj.amt,
        amount: amt,
        balance: 0, //TODO,
        srcAdj: amountObj.srcAdj,
        baseAdj: amountObj.baseAdj,
        isFxApplied: true,
        amountInSourceCurrency: await deriveFxPrice(amt, code),
        conversionRate: conversionRate,
        fxReceived: fxReceived ? fxReceived : 0,
        balanceInBaseCurrency: balanceInBaseCurrency //TODO
          ? balanceInBaseCurrency //TODO
          : 0,
        balanceInSourceCurrency: balanceInSourceCurrency
          ? balanceInSourceCurrency
          : 0,
        balanceCurrencyType: balanceCurrencyType ? balanceCurrencyType : "BASE",
      });
    } else {
      let amt = 0;
      let balanceToPay = getBalanceToPay(mode);
      if (parseFloat(amountObj.amt) > balanceToPay) {
        amt = PricingUtils.formattedNumber(
          balanceToPay,
          props.context.store.currencyDecimal
        );
      } else {
        amt = amountObj.amt;
      }
      arr.push({
        tenderedInActualCurr: amt,
        amountInActualCurr: amt,
        balanceWithCurrency: "0 " + props.context.store.currency,
        code: code,
        tendered: amt,
        amount: amt,
        balance: 0,
        srcAdj: 0,
        baseAdj: 0,
        fxReceived: fxReceived ? fxReceived : 0,
        balanceInBaseCurrency: balanceInBaseCurrency
          ? balanceInBaseCurrency
          : 0,
        balanceInSourceCurrency: balanceInSourceCurrency
          ? balanceInSourceCurrency
          : 0,
        balanceCurrencyType: balanceCurrencyType ? balanceCurrencyType : "BASE",
      });
    }
  }

  function showPaymentInfoInPole(code, newData) {
    let tendered = 0;
    let balance = 0;
    for (let d of newData) {
      if (d.code != "DISCOUNT") {
        tendered = tendered + parseFloat(d.tendered);
        balance = balance + parseFloat(d.balance);
      }
    }
    let value1 = PoleDisplayUtils.prepareValue(
      "Tendered ",
      PricingUtils.formattedNumber(
        tendered,
        props.context.store.currencyDecimal
      )
    );
    let value2 = PoleDisplayUtils.prepareValue(
      "Balance ",
      PricingUtils.formattedNumber(balance, props.context.store.currencyDecimal)
    );

    PoleDisplayUtils.showOnPole(props.terminalBean, value1, value2);
  }

  function validate() {
    if (isNaN(amountObj.amt) || amountObj.amt === "") {
      return false;
    }
    return true;
  }

  function isValidkey(value) {
    return (
      "1" == value ||
      "2" == value ||
      "3" == value ||
      "4" == value ||
      "5" == value ||
      "6" == value ||
      "7" == value ||
      "8" == value ||
      "9" == value ||
      "0" == value ||
      "." == value
    );
  }

  async function getConversionRate(code) {
    if (code) {
      try {
        let dbData = await db.fxrate
          .where("sourceCurrencyCode")
          .equals(code)
          .toArray();
        if (dbData && dbData[0]) {
          return parseFloat(dbData[0].conversionRate);
        }
      } catch (e) {
        console.log("ERROR-", e);
      }
    }
    return 1;
  }

  async function deriveFxPrice(amount, code) {
    let conversionRate = await getConversionRate(code);
    return PricingUtils.formattedNumber(
      amount / conversionRate,
      code === "OMR" ? 3 : props.context.store.currencyDecimal
    );
  }

  async function convertTobase(amount, code) {
    let conversionRate = await getConversionRate(code);
    return PricingUtils.formattedNumber(
      amount * conversionRate,
      props.context.store.currencyDecimal
    );
  }

  async function deriveAmount(selectedPaymentMode) {
    let conversionRate = await getConversionRate(selectedPaymentMode.code);
    setFxConversionRate(conversionRate);
    let found = false;
    let payedAmt = 0;
    for (let d of props.paymentData) {
      if (d.code === selectedPaymentMode.code) {
        found = true;
        if (d.isFxApplied) {
          setAmountObj({
            amt: d.srcTendered,
            srcAdj: d.srcAdj,
            baseAdj: d.baseAdj,
          });
        } else {
          setAmountObj({ amt: d.tendered, srcAdj: 0, baseAdj: 0 });
        }
        setBalance(d.balance);
      }
      payedAmt = payedAmt + parseFloat(d.amount);
    }
    if (!found) {
      let total = parseFloat(props.total);
      if (selectedPaymentMode.isFx) {
        let dervicedAmount = await deriveFxPrice(
          total - payedAmt,
          selectedPaymentMode.code
        );

        let adj = total - payedAmt - dervicedAmount * conversionRate;
        console.log(adj);
        let srcAdj = 0;
        let baseAdj = 0;
        if (adj > 0) {
          let newDervicedAmount = PricingUtils.formattedNumber(
            parseFloat(dervicedAmount) +
              (selectedPaymentMode.code == "OMR" ? 0.001 : 0.01),
            selectedPaymentMode.code == "OMR"
              ? 3
              : props.context.store.currencyDecimal
          );
          baseAdj =
            newDervicedAmount * conversionRate -
            dervicedAmount * conversionRate;
          dervicedAmount = newDervicedAmount;
          srcAdj = selectedPaymentMode.code == "OMR" ? 0.001 : 0.01;
        }

        dervicedAmount = PricingUtils.formattedNumber(
          parseFloat(dervicedAmount) + parseFloat(srcAdj / conversionRate),
          selectedPaymentMode.code == "OMR"
            ? 3
            : props.context.store.currencyDecimal
        );
        setAmountObj({ amt: dervicedAmount, srcAdj: srcAdj, baseAdj: baseAdj });
      } else {
        setAmountObj({ amt: total - payedAmt, baseAdj: 0, srcAdj: 0 });
      }
      setBalance(0);
    }
  }
  function getBalanceToPay(mode) {
    let payedAmt = 0;
    for (let d of props.paymentData) {
      if (mode == "update" && code == d.code) {
      } else payedAmt = payedAmt + parseFloat(d.amount);
    }
    let total = parseFloat(props.total);
    return total - payedAmt;
  }

  function onKeyPressed(event, value) {
    if (event.key === "ArrowUp" || event.key === "ArrowDown") {
      event.preventDefault();
      event.stopPropagation();
    }
    if (event.key === "Delete") {
      event.preventDefault();
      event.stopPropagation();
      setAmountObj({
        amt: "",
        baseAdj: amountObj.baseAdj,
        srcAdj: amountObj.srcAdj,
      });
    }
    //event.preventDefault();
    event.stopPropagation();
  }

  function onA4Print(value, buttonIndex) {
    console.log("value Mpayment", value, buttonIndex);
    props.onKeyPressed(value, setEnableSaleSave, buttonIndex);
  }

  // function onSavePressed(value) {
  //   props.onKeyPressed(value, setEnableSaleSave);
  // }
  return (
    <div style={{ paddingRight: props.isMobile ? 0 : 10 }}>
      <ThemeProvider theme={theme}>
        <Card style={{ background: orange["50"] }}>
          <Grid
            container
            style={{
              padding: 10,
            }}
          >
            <Grid item xs={12}>
              {props.isMobile ? (
                <Typography>{code}</Typography>
              ) : (
                <Typography variant="h6">{code}</Typography>
              )}
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={10}>
              {code === "DISCOUNT" && (
                <Grid
                  container
                  style={{ paddingTop: "5px", paddingBottom: "5px" }}
                >
                  <Grid item xs={6} style={{ paddingRight: "5px" }}>
                    <ActionButton
                      style={{
                        background: isDiscountInPercentage
                          ? grey[700]
                          : orange[700],
                        color: "#ffffff",
                      }}
                      onClick={() => {
                        setIsDiscountInPercentage(false);
                        setDiscountDisplayValue("");
                      }}
                    >
                      FLAT
                    </ActionButton>
                  </Grid>
                  <Grid item xs={6} style={{ paddingLeft: "5px" }}>
                    <ActionButton
                      style={{
                        background: isDiscountInPercentage
                          ? orange[700]
                          : grey[700],
                        color: "#ffffff",
                      }}
                      onClick={() => {
                        setIsDiscountInPercentage(true);
                        setDiscountDisplayValue("");
                      }}
                    >
                      PERCENTAGE
                    </ActionButton>
                  </Grid>
                </Grid>
              )}
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={7}>
              <Typography>
                {translate("Amount")}{" "}
                {code === "DISCOUNT" ? discountDisplayValue : ""}
                {paymentMode && paymentMode.isFx
                  ? " (FX rate: " + fxConversionRate + ")"
                  : ""}
              </Typography>
            </Grid>
            <Grid item xs={4}></Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={10} style={{ background: "#fff", fontSize: "40" }}>
              <PText
                onKeyDown={onKeyPressed}
                onChange={(e) => {
                  if (!isNaN(e.target.value))
                    setAmountObj({
                      amt: e.target.value,
                      baseAdj: amountObj.baseAdj,
                      srcAdj: amountObj.srcAdj,
                    });
                }}
                value={amountObj.amt}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        style={{ color: "red" }}
                        onClick={() => {
                          if (amountObj.amt.length > 0) {
                            setAmountObj({
                              amt: amountObj.amt.substring(
                                0,
                                amountObj.amt.length - 1
                              ),
                              baseAdj: amountObj.baseAdj,
                              srcAdj: amountObj.srcAdj,
                            });
                          }
                        }}
                      >
                        <BackspaceIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              ></PText>
            </Grid>
            <Grid item xs={1}></Grid>

            <Grid item xs={12}>
              {showBalance && (
                <Grid container>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={10}>
                    <Typography>
                      {translate("Balance")}{" "}
                      {paymentMode && paymentMode.isFx && (
                        <table width="100%">
                          <tbody>
                            <tr>
                              <td>
                                <PCheck
                                  onChange={(value) => {
                                    setIsBalanceInBaseCurrency(value);
                                    setIsBalanceInSourceCurrency(
                                      value ? false : true
                                    );
                                    setBalanceInSourceCurrency(0);
                                    setBalanceCurrencyType("BASE");
                                  }}
                                  checked={isBalanceInBaseCurrency}
                                  label={props.context.store.currency}
                                ></PCheck>
                              </td>
                              <td>
                                <PCheck
                                  onChange={(value) => {
                                    setIsBalanceInSourceCurrency(value);
                                    setIsBalanceInBaseCurrency(
                                      value ? false : true
                                    );
                                    setBalanceInBaseCurrency(0);
                                    setBalanceCurrencyType("SOURCE");
                                  }}
                                  checked={isBalanceInSourceCurrency}
                                  label={paymentMode.code}
                                ></PCheck>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      )}
                    </Typography>
                  </Grid>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={1}></Grid>
                  <Grid
                    item
                    xs={10}
                    style={{ background: "#fff", fontSize: "40" }}
                  >
                    <PText
                      value={balance}
                      InputProps={{
                        readOnly: true,
                      }}
                    ></PText>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Card>
        <Grid item xs={1}></Grid>
      </ThemeProvider>

      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
      {showDiscountApprovalWindow && (
        <PAuthenticationWindow
          context={props.context}
          handleLoginSucessResponse={handleLoginSucessResponse}
          showWindow={setShowDiscountApprovalWindow}
        ></PAuthenticationWindow>
      )}
      <div>
        <Grid container>
          <Grid
            style={{
              position: "absolute",
              bottom: "3%",
              right: "34%",
            }}
          >
            <table>
              <tbody>
                <tr>
                  {selectPrinter.map(
                    (item, index) =>
                      item && (
                        <td>
                          <ActionButton
                            disabled={!enableSaleSave}
                            onClick={() => {
                              setEnableSaleSave(false);
                              onA4Print("Print", 1);
                            }}
                            style={{ height: "61px" }}
                          >
                            <div
                              style={{
                                width: "100%",
                              }}
                            >
                              <Grid container>
                                <Grid item xs={12}>
                                  {item.label}
                                </Grid>
                                {props.context.saleSetting &&
                                  props.context.saleSetting
                                    .showKeyboardShortcuts && (
                                    <Grid
                                      item
                                      xs={12}
                                      style={{ fontSize: "0.60rem" }}
                                    >
                                      {item.keyBoardShortCut}
                                    </Grid>
                                  )}
                              </Grid>
                            </div>
                          </ActionButton>
                        </td>
                      )
                  )}
                </tr>
              </tbody>
            </table>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
